import { of, zip } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
import { ChatMiscDataPlugin } from 'src/features/messaging/chat/components/methods/misc';
/**
 * Plugin containing method to update
 * if current user is typing in the firestore
 */
const ChatTypingPlugin = () => {
    const { user, convo } = ChatMiscDataPlugin();
    const { subject: typingUpdate$ } = rxInitSubjectCallback();
    function updateTyping(boo) {
        typingUpdate$.next(boo);
    }
    useObservable(typingUpdate$.pipe(switchMap(boo => {
        return of(boo).pipe(switchMap(() => {
            return import(/* webpackChunkName: "firebaseMethod" */ 'src/_helpers/firebaseMethods');
        }), map(({ default: firebaseMethods }) => firebaseMethods), switchMap(firebaseMethods => {
            return zip(firebaseMethods(), import(
            /* webpackChunkName: "firebaseMethod" */
            'firebase/firestore'));
        }), tap(([{ db }, { doc: fbDoc, updateDoc }]) => {
            void updateDoc(fbDoc(db, 'chat', convo.value.id), {
                [`typing_${user.value.user_pk}`]: boo
            });
        }));
    })));
    return {
        updateTyping
    };
};
export { ChatTypingPlugin };
